import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import {showError} from 'perform-base/js/flashes';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentProject: {},
    tasks: [],
    currentTask: {},
    notes: [],
    posts: [],
  },

  getters: {
    tasksByStatus: (state) => (status) => {
      return state.tasks.filter(task => task.status === status);
    },
    currentProjectId(state) {
      if (state.currentProject.id) {
        return state.currentProject.id;
      }
      if (state.currentTask.project) {
        return state.currentTask.project.id;
      }
      return null;
    },
    noteById: (state) => (id) => {
      for (let note of state.notes) {
        if (note.id === id) {
          return note;
        }
      }
      return null;
    }
  },

  mutations: {
    setTasks(state, tasks) {
      state.tasks = tasks;
    },

    addTask(state, task) {
      state.tasks.unshift(task);
    },
    setNotes(state, notes) {
      state.notes = notes;
    },
    addNote(state, note) {
      state.notes.push(note);
    },
    editNote(state, data) {
      state.notes.forEach(note => {
        if (data.id === note.id) {
          note.markdown = data.markdown;
          note.html = data.html;
          note.type = data.type;
          note.files = data.files;
        }
      });
    },

    setCurrentProject(state, project) {
      state.currentProject = project;
    },

    setPosts(state, posts) {
      state.posts = posts;
    },

    setContactDetails(state, data) {
      state.contactDetails = data;
    }
  },

  actions: {
    loadTasks(context, payload) {
      let params = {};
      if (!payload.projectId) {
        return;
      }

      axios.get('/api/tasks/project/'+payload.projectId, {
        params: params
      }).then(function(response) {
          context.commit('setTasks', response.data.tasks);
        });
    },
    createTask(context, payload) {
      return axios.post('/api/tasks/create', payload)
        .then(r => r.data);
    },

    loadNotes(context, payload) {
      const url = '/notes/get/' + payload.entityType + '/' + payload.entityId;
      return axios.get(url)
        .then(response => {
          context.commit('setNotes', response.data);
        });
    },
    createNote(context, payload) {
      const url = '/notes/add/' + payload.entityType + '/' + payload.entityId;
      const data = {
        markdown: payload.markdown,
        type: payload.type,
      };
      return axios.post(url, data)
        .then(response => {
          return updateNoteFiles(Object.assign({}, payload, {id: response.data.id}), [])
            .then(files => {
              context.commit('addNote', Object.assign({}, response.data, {files}));
            });
        });
    },
    editNote(context, payload) {
      const url = '/notes/edit/' + payload.id;
      const data = {
        markdown: payload.markdown,
        type: payload.type,
      };
      return axios.post(url, data)
        .then(response => {
          return updateNoteFiles(payload, context.getters.noteById(payload.id).files)
            .then(files => {
              context.commit('editNote', Object.assign({}, response.data, {files}));
            });
        });
    },

    setCurrentProjectStatus(context, payload) {
      return axios.post('/api/projects/set-status/'+context.state.currentProject.id + '/' + payload.status)
        .then(response => {
          context.commit('setCurrentProject', response.data.project);
        });
    },

    loadPosts(context, payload) {
      let params = {};
      if (!payload.projectId) {
        return;
      }

      axios.get('/api/chats/project/'+payload.projectId, {
        params: params
      }).then(function(response) {
          context.commit('setPosts', response.data.posts);
        });
    }
  }
});

function updateNoteFiles(payload, existingFiles) {
  let promises = [];
  let removedIds = [];
  let editedIds = [];
  const noteId = payload.id;

  for (let item of payload.files) {
    if (item._action === 'new') {
      let data = new FormData();
      data.append('name', item.name);
      data.append('file', item._file);
      promises.push(axios.post(`/notes/add-attachment/${noteId}`, data));
    }
    if (item._action === 'remove') {
      promises.push(axios.post(`/notes/remove-attachment/${item.id}`));
      removedIds.push(item.id);
    }
    if (item._action === 'edit') {
      promises.push(axios.post(`/notes/edit-attachment/${item.id}`, {
        name: item.name,
      }));
      editedIds.push(item.id);
    }
  }

  return Promise.allSettled(promises)
    .then(results => {
      let files = [];

      for (let result of results) {
        if (result.status === 'rejected') {
          const error = result.reason.response.data.error;
          showError(error);
          console.error(error);
          continue;
        }
        if (result.value.data && result.value.data.id) {
          files.push(result.value.data);
        }
      }

      for (let existingFile of existingFiles) {
        // don't add deleted files
        if (removedIds.indexOf(existingFile.id) !== -1) {
          continue;
        }

        // add unchanged files
        if (editedIds.indexOf(existingFile.id) === -1) {
          files.push(existingFile);
          continue;
        }
      }
      // TODO: sort files by createdAt ASC

      return files;
    });
}



// WEBPACK FOOTER //
// ./assets/js/store.js